import React from "react";

function LoadingSpinner() {
    return <img src="/loading-spinner.svg" alt="Loading..."/>
}

export default LoadingSpinner;
